module.exports = __webpack_public_path__ + "img/42-l.8eb51eab.png";